<template>
  <div class="content">
    <div class="section">
      <h1 class="section-head">发票信息</h1>
      <div class="section-body">
        <a class="invoice-guide" href="/v2/dist/help.html#22" target="_blank" rel="opener">发票开具如有疑问请查看使用引导，点击跳转>></a>
        <el-form :model="invoiceInfo" :rules="rules" ref="invoiceForm" size="small" label-width="160px">
          <el-form-item label="开票方式:" prop="invoiceMode" v-auth="'pre_invoice'">
            <el-select v-model="invoiceInfo.invoiceMode" @change="invoiceModeChange">
              <el-option v-for="it in invoiceModes" :value="it.invoiceMode" :label="it.invoiceModeName" :key="it.invoiceMode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票抬头:" prop="companyName">
            <el-select v-model="invoiceInfo.companyName">
              <el-option v-for="it in companyNames" :value="it.value" :label="it.name" :key="it.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票颜色:" prop="invoiceColor">
            <el-select v-model="invoiceInfo.invoiceColor" @change="invoiceColorChange">
              <el-option v-for="it in invoiceColors" :value="it.invoiceColorId" :label="it.invoiceColorName" :key="it.invoiceColorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型:" prop="invoiceType">
            <el-select v-model="invoiceInfo.invoiceType" @change="invoiceTypeChange">
              <el-option v-for="it in invoiceTypes" :value="it.invoiceTypeId" :label="it.invoiceTypeName" :key="it.invoiceTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票对应项目:" prop="applyProject">
            <el-select v-model="invoiceInfo.applyProject" @change="applyProjectChange">
              <el-option v-for="it in applyProjects" :value="it.applyProjectId" :label="it.applyProjectName" :key="it.applyProjectId + '_' + it.miCompanyId"></el-option>
            </el-select>
            <div class="invoiceProject-info" v-if="!hideTip">
              根据国家对增值税发票的最新要求，EMI平台所开具发票的【发票对应项目】已更新。原【广告发布费  】更新为【*广告服务*广告发布费】，原【*信息技术服务*信息服务费】更新为【*信息系统增值服务*信息服务费】。
            </div>
          </el-form-item>
          <el-form-item label="服务提供方:">
            <el-select v-model="miCompanyId" @change="miCompanyIdChange">
              <el-option v-for="it in miCompanys" :value="it.miCompanyId" :label="it.miCompanyName" :key="it.miCompanyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推广产品名称:" prop="productionName">
            <el-input v-model="invoiceInfo.productionName"></el-input>
          </el-form-item>
          <el-form-item label="申请原因:" prop="invoiceReason" v-if="invoiceInfo.invoiceColor == invoiceData.InvoiceColor.RED">
            <el-select v-model="invoiceInfo.invoiceReason" @change="invoiceReasonChange">
              <el-option v-for="it in applyReasons" :value="it.reasonId" :label="it.displayName" :key="it.reasonId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值总额:" v-if="invoiceInfo.invoiceMode == invoiceData.InvoiceMode.NORMAL && invoiceInfo.invoiceColor == invoiceData.InvoiceColor.BLUE">
            <span>¥{{rechargeSumAmount | formatNum(',.2')}}</span>
          </el-form-item>
          <el-form-item label="未开发票总额:" v-if="showNotInvoiceAmount">
            <span>¥{{notInvoiceAmount || 0 | formatNum(',.2')}}</span>
            <el-button v-if="invoiceInfo.invoiceColor == invoiceData.InvoiceColor.BLUE" type="primary" plain size="small" @click="triggerSelectInvoice(true)">选择发票金额</el-button>
          </el-form-item>
          <template v-if="invoiceInfo.invoiceColor == invoiceData.InvoiceColor.RED">
            <el-form-item label="已开蓝票总额:">
              <span>¥{{blueInvoiceAmount | formatNum(',.2')}}</span>
            </el-form-item>
            <el-form-item label="红字信息表:" prop="informationFile" :class="{'is-required': isRedInformationRequired}">
              <el-upload
                :action="'/v4/finance/invoice/uploadInformationSheet'"
                :show-file-list="false"
                :data="uploadParams"
                :disabled="uploading"
                accept=".pdf,.jpg,.jpeg,.png"
                :before-upload="beforeUpInfoSheet"
                :on-success="upInfoSheetSuccess"
                :on-error="upInfoSheetError"
              >
                <el-button size="small" type="primary" :loading="uploading">{{uploading ? '上传中' : '点击上传'}}</el-button>
                <span class="tip-text">注：纸质发票上传pdf附件，数电发票上传图片附件</span>
                <p v-show="fileName && invoiceInfo.informationFile" style="text-align: left;">{{ fileName }}</p>
              </el-upload>
            </el-form-item>
            <el-form-item label="红字发票申请明细:">
              <el-row>
                <el-col :span="7">
                  <el-form-item label="红字信息表编号:" prop="informationSheetId" :class="{'is-required': isRedInformationRequired}">
                    <el-input v-model="invoiceInfo.informationSheetId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="价税合计（元）:" prop="taxInclusiveTotalAmount">
                    <el-input v-model="invoiceInfo.taxInclusiveTotalAmount" type="number" placeholder="输入负数" @input="debouncedAmountChange"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <el-form-item label="原发票号码:" prop="originInvoiceId">
                    <el-select v-model="invoiceInfo.originInvoiceId" placeholder="请选择原发票号" @change="originInvoiceIdsChange">
                      <el-option v-for="it in originInvoiceIds" :value="it.id" :label="it.invoiceNum" :key="it.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="原发票代码:" prop="originInvoiceCode">
                    <el-input v-model="originInvoiceCode" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="原发票金额:">
                    <span>¥{{originInvoiceAmount | formatNum(',.2')}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="原发票可开红票金额:">
                    <span>¥{{originInvoiceRedAmount | formatNum(',.2')}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="invoiceInfo.invoiceReason != invoiceData.RedApplyReason.HAS_REBEATE">
                <el-form-item prop="recordIds">
                  <invoice-record v-model="invoiceInfo.recordIds" title="充值记录" :list="rechargeRecords" :columns="invoiceData.RechargeColumns"></invoice-record>
                </el-form-item>
                <el-form-item prop="deductIds">
                  <invoice-record v-model="invoiceInfo.deductIds" title="退款记录" :disabled="true" :list="deductRecords" :columns="invoiceData.DeductColumns"></invoice-record>
                </el-form-item>
              </template>
            </el-form-item>
          </template>
          <el-form-item v-if="invoiceInfo.invoiceMode == invoiceData.InvoiceMode.NORMAL" label="发票金额:" prop="invoiceAmount">
            <span >¥{{invoiceInfo.invoiceAmount | formatNum(',.2')}}</span>
          </el-form-item>
          <template v-if="invoiceInfo.invoiceMode == invoiceData.InvoiceMode.PRE">
            <el-form-item label="发票金额:" prop="preAmount" key="preAmount">
              <el-input v-model="invoiceInfo.preAmount" type="number"></el-input>元
            </el-form-item>
            <el-form-item label="发票备注:" prop="invoiceDesc">
              <el-input v-model="invoiceInfo.invoiceDesc" type="textarea" maxlength="50"></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </div>
    <div class="section">
      <h1 class="section-head">发票资质</h1>
      <invoice-qualification :special-invoice="specialInvoice" :invoiceType="invoiceInfo.invoiceType" :tax-id="taxId" @edit="editQualiy"></invoice-qualification>
    </div>
    <div class="section">
      <h1 class="section-head">收货人信息</h1>
      <div class="section-body">
        <shipping-address v-for="(item, i) in addressList" :key="`${item.id}_${i}`" :address="item" :index="i" :selected="address && address.id" @select="selectAddress" @delete="deleteItem" @save="saveSuccess"></shipping-address>
        <div class="add-address add-box" v-show="addressList.length < 5" @click="addAddress"><i class="el-icon-plus"></i>添加收货人信息</div>
      </div>
      <div class="section-body">
        <el-button type="primary" @click="applyInvoice">申请发票</el-button>
      </div>
    </div>
    <select-invoice
      :recordIds="invoiceInfo.recordIds"
      :visible="isShowSelectInvoice"
      :recharge-records="blueRechargeRecords"
      :deduct-records="notInvoiceData.deductRecordList"
      :recharge-columns="invoiceData.RechargeColumns"
      :deduct-columns="invoiceData.DeductColumns"
      @changeVisible="triggerSelectInvoice">
    </select-invoice>
  </div>
</template>
<script>
  import * as invoiceData from '../utils/consts.js';
  import {getCompanyName, getNotInvoiceList, getSpecialInvoice, getReceiverList, invoiceApply, getInvoiceModes, initParams} from '../utils/api.js';
  import {numUtils} from 'common/utils.js';
  import SelectInvoice from '../comps/select-invoice.vue';
  import InvoiceQualification from '../comps/invoice-qualification.vue';
  import ShippingAddress from '../comps/shipping-address.vue';
  import InvoiceRecord from '../comps/InvoiceRecord.vue';
  import debounce from 'lodash/debounce';
  import {AccountInfo} from 'common/axios.js';
  export default {
    name: 'invoice',
    data() {
      const that = this;
      return {
        invoiceInfo: {
          invoiceMode: '',
          companyName: '',
          applyProject: '',
          invoiceColor: '',
          invoiceType: '',
          productionName: '',
          invoiceReason: '',
          informationSheetId: '',
          taxInclusiveTotalAmount: '',
          invoiceAmount: '',
          informationFile: '',
          preAmount: '',
          originInvoiceId: '',
          recordIds: [],
          deductIds: [],
          invoiceDesc: '',
          contractType: ''
        },
        fileName: '',
        uploading: false,
        taxId: '',
        miCompanyId: '',
        rechargeSumAmount: '',
        notInvoiceAmount: 0, //未开发票总金额
        blueInvoiceAmount: 0, //已开蓝票总金额
        hideTip: true,
        companyNames: [],
        addressList: [],
        address: null,
        specialInvoice: null,
        notInvoiceData: {}, //待开发票列表, 选择发票金额弹窗内容
        isNormalInvoice: true,
        isShowSelectInvoice: false,
        rechargeRecords: [],
        deductRecords: [],
        originInvoiceIds: [],
        originInvoiceCode: '',
        originInvoiceAmount: '', // 红票时 原发票金额
        originInvoiceRedAmount: '', // 红票时 原发票可开红票金额
        invoiceData,
        invoiceModes: [],
        invoiceTypes: [],
        invoiceColors: [],
        applyProjects: [],
        miCompanys: [],
        miCompanyName: '',
        applyReasons: [],
        rules: {
          invoiceMode: {required: true, message: '请选择开票方式', trigger: 'change'},
          companyName: {required: true, message: '请选择发票抬头', trigger: 'change'},
          applyProject: {required: true, message: '请选择发票对应项目', trigger: 'change'},
          invoiceColor: {required: true, message: '请选择发票颜色', trigger: 'change'},
          invoiceType: {required: true, message: '请选择发票类型', trigger: 'change'},
          productionName: {
            required: true,
            validator: (rule, value, callBack) => {
              if (!value || !value.trim()) {
                callBack(new Error('请输入推广产品名称'));
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          invoiceReason: {required: true, message: '请选择申请原因', trigger: 'change'},
          invoiceAmount: {
            required: true,
            validator: (rule, value, callBack) => {
              if (!value || +value == 0) {
                callBack(new Error('发票金额不能为0'));
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          informationFile: {
            validator: (rule, value, callBack) => {
              const {invoiceType, invoiceReason} = this.invoiceInfo;
              const {InvoiceType, RedApplyReason} = invoiceData;
              if (invoiceReason == RedApplyReason.BLUE_CANCEL) {
                callBack();
              } else if (invoiceType == InvoiceType.SPECIAL || invoiceType == InvoiceType.DIGITAL_SPECIAL) {
                if (!value || !value.trim()) {
                  callBack(new Error('请上传红字信息表'));
                } else {
                  callBack();
                }
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          informationSheetId: {
            validator: (rule, value, callBack) => {
              const {invoiceType, invoiceReason} = this.invoiceInfo;
              const {InvoiceType, RedApplyReason} = invoiceData;
              if (invoiceReason == RedApplyReason.BLUE_CANCEL) {
                callBack();
              } else if (invoiceType == InvoiceType.SPECIAL || invoiceType == InvoiceType.DIGITAL_SPECIAL) {
                if (!value || !value.trim()) {
                  callBack(new Error('请输入红字发票信息表编号'));
                } else {
                  callBack();
                }
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          taxInclusiveTotalAmount: {
            required: true,
            validator: (rule, value, callBack) => {
              const {invoiceType} = this.invoiceInfo;
              const {InvoiceType} = invoiceData;
              if (!value || !value.trim()) {
                callBack(new Error('请输入价税合计'));
              } else if (+value >= 0 && (invoiceType == InvoiceType.NORMAL || invoiceType == InvoiceType.DIGITAL_NORMAL)) {
                callBack(new Error('输入价税合计应为负数'));
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          originInvoiceId: {required: true, message: '请选择原发票号码', trigger: 'change'},
          preAmount: {
            required: true,
            validator: (rule, value, callBack) => {
              console.log(value)
              if (!value || !value.trim()) {
                callBack(new Error('请输入发票金额'));
              } else if (+value <= 0) {
                callBack(new Error('发票金额必须大于0'));
              } else {
                callBack();
              }
            },
            trigger: 'change'
          },
          recordIds: {
            required: true,
            validator: (rule, value, callBack) => {
              const {invoiceReason} = that.invoiceInfo;
              const {RedApplyReason} = invoiceData;
              if ((invoiceReason != RedApplyReason.HAS_DEDUCT || invoiceReason == RedApplyReason.HAS_DEDUCT && that.rechargeRecords.length > 0) && (!value || value.length == 0)) {
                callBack(new Error('请选择充值记录'));
              } else {
                callBack();
              }
            }
          }
        },
        uploadParams: {},
      }
    },
    computed: {
      showNotInvoiceAmount() {
        const {invoiceMode, invoiceColor, invoiceReason} = this.invoiceInfo;
        const {InvoiceColor, InvoiceMode, RedApplyReason} = invoiceData;
        return invoiceMode == InvoiceMode.NORMAL && (invoiceColor == InvoiceColor.BLUE || invoiceColor == InvoiceColor.RED && invoiceReason == RedApplyReason.HAS_DEDUCT);
      },
      hasSpecial() {
        return this.invoiceTypes.find(it => it.invoiceTypeId == invoiceData.InvoiceType.SPECIAL || it.invoiceTypeId == invoiceData.InvoiceType.DIGITAL_SPECIAL);
      },
      blueRechargeRecords() {
        if (this.invoiceInfo.applyProject && this.miCompanyName && this.notInvoiceData && this.notInvoiceData.applyInvoiceDTOList) {
          const project = this.notInvoiceData.applyInvoiceDTOList.find(it => it.applyProjectId == this.invoiceInfo.applyProject && it.miCompanyName == this.miCompanyName);
          const records = (project || {}).records || [];
          return records;
        }
        return [];
      },
      isRedInformationRequired() {
        const {invoiceType, invoiceReason} = this.invoiceInfo;
        const {InvoiceType, RedApplyReason} = invoiceData;
        if (invoiceReason == RedApplyReason.BLUE_CANCEL) {
          return false;
        } else if (invoiceType == InvoiceType.SPECIAL || invoiceType == InvoiceType.DIGITAL_SPECIAL) {
          return true
        } else {
         return false;
        }
      }
    },
    watch: {
      'invoiceInfo.invoiceType': function(v) {
        if (v == invoiceData.InvoiceType.SPECIAL) {
          this.getSpecialInvoiceData();
        }
      },
      'invoiceInfo.companyName': function(v) {
        this.getInvoiceModes();
      },
      'invoiceInfo.invoiceMode': function(v) {
        this.invoiceInfo.invoiceDesc = '';
        this.invoiceInfo.invoiceAmount = '';
        this.invoiceInfo.recordIds = null;
        this.invoiceInfo.deductIds = null;
        this.invoiceInfo.preAmount = null;
      }
    },
    filters: {
      formatNum: numUtils.formatNum
    },
    components: {
      SelectInvoice,
      InvoiceQualification,
      ShippingAddress,
      InvoiceRecord
    },
    created() {
      this.getCompanyName();
      this.getReceiverList();
    },
    async mounted() {
      const params = await initParams({});
      Object.assign(this.uploadParams, params);
      const account = AccountInfo.getAccountFromSys();
      this.uploadParams.emiAccountId = params.accountType != 1 ? `${params.accountId}${params.accountType}` : account.customerId;
      this.debouncedAmountChange = debounce(this.changeAmount, 500);
    },
    methods: {
      changeAmount(val) {
        this.invoiceInfo.invoiceAmount = val;
        this.getNotInvoiceList();
        // console.log(val)
      },
      beforeUpInfoSheet(file) {
        this.fileName = file.name;
        this.uploading = true;
      },
      upInfoSheetSuccess({result, success}) {
        this.uploading = false;
        if (result && success) {
          this.invoiceInfo.informationFile = result.url;
        }
      },
      upInfoSheetError() {
        this.uploading = false;
        this.$message.error('上传失败，请重试');
      },
      async getInvoiceModes() {
        const {companyName} = this.invoiceInfo;
        if (!companyName) return;
        const result = await getInvoiceModes({companyName});
        this.invoiceModes = result;
        this.invoiceInfo.invoiceMode = (this.invoiceModes[0] || {}).invoiceMode || '';
        this.invoiceModeChange(this.invoiceInfo.invoiceMode);
      },
      invoiceModeChange(mode) {
        const select = this.invoiceModes.find(it => it.invoiceMode == mode) || {};
        this.invoiceColors = select.invoiceColor || [];
        this.invoiceInfo.invoiceColor = (this.invoiceColors[0] || {}).invoiceColorId;
        this.invoiceColorChange(this.invoiceInfo.invoiceColor);
      },
      invoiceColorChange(color) {
        const select = this.invoiceColors.find(it => it.invoiceColorId == color) || {};
        this.invoiceTypes = select.invoiceType || [];
        const applyProjects = [], cacheId = []; // 可能会存在applyProjectId相同的，但miCompanyId不同单
        for (let i = 0; i < (select.applyProject || []).length; i++) {
          const it = select.applyProject[i];
          if (!cacheId.includes(it.applyProjectId)) {
            applyProjects.push(it);
            cacheId.push(it.applyProjectId);
          }
        }
        this.applyProjects = applyProjects;
        this.allApplyProjects = select.applyProject || []; // 存一个全量的，方便后边处理服务提供方
        this.applyReasons = select.applyReason || [];
        this.invoiceInfo.invoiceAmount = '';
        //是否有专票资质,如果有，发票类型默认选中专票
        const hasSpecial = this.invoiceTypes.find(it => it.invoiceTypeId == invoiceData.InvoiceType.SPECIAL || it.invoiceTypeId == invoiceData.InvoiceType.DIGITAL_SPECIAL);
        this.invoiceInfo.invoiceType = hasSpecial ? hasSpecial.invoiceTypeId : (this.invoiceTypes[0] || {}).invoiceTypeId;
        this.invoiceInfo.applyProject = (this.applyProjects[0] || {}).applyProjectId;
        this.invoiceInfo.invoiceReason = (this.applyReasons[0] || {}).reasonId;
        this.applyProjectChange(this.invoiceInfo.applyProject);
        if (hasSpecial) {
          this.getSpecialInvoiceData();
        }
      },
      resetInvoiceInfo(color) {
        if (color == invoiceData.InvoiceColor.BLUE) {
          this.invoiceInfo.informationFile = '';
          this.invoiceInfo.informationSheetId = '';
          this.invoiceInfo.taxInclusiveTotalAmount = '';
          this.invoiceInfo.originInvoiceId = '';
          this.invoiceInfo.invoiceReason = '';
        }
      },
      applyProjectChange(applyProject) {
        const select = this.applyProjects.find(it => it.applyProjectId == applyProject) || {};
        this.miCompanys = this.allApplyProjects.filter(it => it.applyProjectId == applyProject).map(it => {
          return {
            miCompanyId: it.miCompanyId,
            miCompanyName: it.miCompanyName,
            amount: it.amount,
            contractId: it.contractId,
            blueInvoiceAmount: it.blueInvoiceAmount
          }
        });
        const company = this.miCompanys[0] || {};
        this.invoiceInfo.contractType = company.contractId;
        this.miCompanyId = company.miCompanyId || '';
        this.miCompanyName = company.miCompanyName || '';
        this.notInvoiceAmount = company.amount || '';
        this.blueInvoiceAmount = company.blueInvoiceAmount || '';
        this.invoiceInfo.invoiceAmount = this.invoiceInfo.invoiceColor == invoiceData.InvoiceColor.BLUE ? '' : this.invoiceInfo.taxInclusiveTotalAmount || '';
        this.invoiceInfo.recordIds = [];
        this.invoiceInfo.deductIds = [];
        this.getNotInvoiceList();
      },
      miCompanyIdChange(miCompanyId) {
        const select = this.miCompanys.find(it => it.miCompanyId == miCompanyId) || {};
        this.notInvoiceAmount = select.amount || '';
        this.blueInvoiceAmount = select.blueInvoiceAmount || '';
        this.miCompanyName = select.miCompanyName || '';
        this.invoiceInfo.contractType = select.contractId;
        this.invoiceInfo.invoiceAmount = this.invoiceInfo.invoiceColor == invoiceData.InvoiceColor.BLUE ? '' : this.invoiceInfo.taxInclusiveTotalAmount || '';
        this.invoiceInfo.recordIds = [];
        this.invoiceInfo.deductIds = [];
        this.getNotInvoiceList();
      },
      originInvoiceIdsChange() {
        this.setRecords();
      },
      invoiceTypeChange(invoiceTypeId) {
        const {InvoiceType} = invoiceData;
        if (this.hasSpecial && ![InvoiceType.SPECIAL, InvoiceType.DIGITAL_SPECIAL].includes(invoiceTypeId)) {
          const select = this.invoiceTypes.find(it => it.invoiceTypeId == invoiceTypeId);
          this.$confirm(`您有${this.hasSpecial.invoiceTypeName}开票资质，请确认是否要开具${select.invoiceTypeName}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {}).catch(() => {
            this.invoiceInfo.invoiceType = this.hasSpecial.invoiceTypeId;
          });
        }
      },
      invoiceReasonChange() {
        if (!this.invoiceInfo.invoiceAmount) return;
        this.getNotInvoiceList();
        
      },
      setRecords() {
        const {invoiceReason, originInvoiceId} = this.invoiceInfo;
        const {invoiceRecordList} = this.notInvoiceData;
        const select = invoiceRecordList.find(it => it.id == originInvoiceId) || {};
        if (invoiceReason == invoiceData.RedApplyReason.HAS_REBEATE) {
          this.invoiceInfo.recordIds = [];
          this.invoiceInfo.deductIds = [];
        } else if (invoiceReason == invoiceData.RedApplyReason.HAS_DEDUCT) {
          const {applyProject} = this.invoiceInfo;
          const apply = this.notInvoiceData.applyInvoiceDTOList.filter(it => it.applyProjectId == applyProject && this.miCompanyName == it.miCompanyName);
          const records = apply.length ? apply[0].records : [];
          this.rechargeRecords = records;
          this.invoiceInfo.recordIds = records.map(it => it.recordId);
          this.deductRecords = this.notInvoiceData.deductRecordList;
          this.invoiceInfo.deductIds = this.deductRecords.map(it => it.id);
        } else if (invoiceReason == invoiceData.RedApplyReason.BLUE_CANCEL) {
          this.rechargeRecords = select.rechargeRecords || [];
          this.invoiceInfo.recordIds = this.rechargeRecords.map(it => it.recordId);
          this.deductRecords = select.deductRecords || [];
          this.invoiceInfo.deductIds = this.deductRecords.map(it => it.id);
        }
        this.originInvoiceCode = select.invoiceCode;
        this.originInvoiceAmount = select.amount || '';
        this.originInvoiceRedAmount = select.redInvoiceAmount || '';
      },
      triggerSelectInvoice(visible, data) {
        this.isShowSelectInvoice = visible;
        data && Object.assign(this.invoiceInfo, data);
      },
      selectAddress(address) {
        this.address = address;
      },
      addAddress() {
        this.addressList.push({
          id: 0,
          receiverName: '',
          telNum: '',
          addressProvince: '',
          addressCity: '',
          addressDistrict: '',
          addressDetail: '',
          email: ''
        });
      },
      deleteItem(index) {
        let isSelect = this.addressList[index].id === this.address.id;
        this.addressList.splice(index, 1);
        if (isSelect) {
          let i = index - 1 >= 0 ? index - 1: 0;
          this.address = this.addressList.length ? this.addressList[i] : null;
        }
      },
      saveSuccess(index, data) {
        Object.assign(this.addressList[index], data);
        this.address = data;
      },
      async getReceiverList() {
        const result = await getReceiverList();
        if (result) {
          this.addressList = result.list;
          result.list.length > 0 && (this.selectAddress(result.list[0]));
        }
      },
      async getCompanyName() {
        const result = await getCompanyName();
        if (result) {
          this.companyNames = result.companyName.map(it => {
            return {name: it, value: it};
          });
          this.taxId = result.taxId;
          this.invoiceInfo.companyName = this.companyNames.length ? this.companyNames[0].value : '';
          // this.getInvoiceModes();
        }
      },
      // 取未开发票列表
      async getNotInvoiceList() {
        if (!this.invoiceInfo.companyName) return;
        const {invoiceType, invoiceMode, invoiceColor, contractType, invoiceAmount, companyName, applyProject, invoiceReason} = this.invoiceInfo;
        const params = {
          invoiceType,
          invoiceMode,
          invoiceColor,
          contractType,
          companyName,
          invoiceReason,
          applyProjectId: applyProject,
          miCompanyId: this.miCompanyId
        };
        if (invoiceColor == invoiceData.InvoiceColor.RED) {
          if (!invoiceAmount) return;
          params.invoiceAmount = invoiceAmount;
        }
        const result = await getNotInvoiceList(params);
        if (result) {
          this.rechargeSumAmount = result.rechargeSumAmount;
          this.hideTip = result.account.createTime.time >= new Date('2019-01-01 00:00:00').getTime();
          this.notInvoiceData = result;
          if (invoiceColor == invoiceData.InvoiceColor.RED) {
            const {invoiceRecordList = []} = result;
            this.originInvoiceIds = invoiceRecordList.map(it => {
              return {
                invoiceNum: it.invoiceNum,
                id: it.id
              }
            });
            this.invoiceInfo.originInvoiceId = (this.originInvoiceIds[0] || {}).id || '';
            this.originInvoiceCode = (invoiceRecordList[0] || {}).invoiceCode || '';
            this.originInvoiceAmount = (invoiceRecordList[0] || {}).amount || '';
            this.originInvoiceRedAmount = (invoiceRecordList[0] || {}).redInvoiceAmount || '';
            this.setRecords();
            // this.rechargeRecords = this.invoiceInfo.originInvoiceId ? invoiceRecordList[0].rechargeRecords || [] : [];
            // this.invoiceInfo.recordIds = this.rechargeRecords.map(it => it.recordId);
            // // 红票时，退款记录选项为原发票票号对应的退款记录和未开过蓝票的退款记录
            // this.deductRecords = this.invoiceInfo.originInvoiceId ? (invoiceRecordList[0].deductRecords || []).concat(result.deductRecordList || []) : [];
            // this.invoiceInfo.deductIds = this.deductRecords.map(it => it.recordId);
          }
        }
      },
      async getSpecialInvoiceData() {
        if (!this.invoiceInfo.companyName) return;
        const result = await getSpecialInvoice({
          companyName: this.invoiceInfo.companyName,
          invoiceType: this.invoiceInfo.invoiceType
        });
        if (result) {
          result.companyAddress = result.companyAdress || '';
          this.specialInvoice = result;
        }
      },
      editQualiy() {
        this.getSpecialInvoiceData();
      },
      applyInvoice() {
        console.log(this.invoiceInfo)
        const {InvoiceType, InvoiceMode} = invoiceData;
        const specialStatus = this.specialInvoice && this.specialInvoice.status || '';
        if ([InvoiceType.SPECIAL, InvoiceType.DIGITAL_SPECIAL].includes(this.invoiceInfo.invoiceType) && specialStatus != 2) {
          this.$alert('选择增值税专用发票必须专票资质通过审核，请检查');
          return;
        }
        if ([InvoiceType.NORMAL, InvoiceType.DIGITAL_NORMAL].includes(this.invoiceInfo.invoiceType) && this.taxId == '') {
          this.$alert('纳税人识别号不能为空。如需添加，请提供您的账户名称与账户ID、三证（五证）合一后的《营业执照》（含统一社会信用代码）或《税务登记证副本》扫描件发送至ad-audit@xiaomi.com，并注明更新企业税务登记证号。');
          return;
        }
        if (!this.address || !this.address.id) {
          this.$alert('请选择或新建一个收货人信息');
          return;
        }
        this.$refs.invoiceForm.validate(flag => {
          if (!flag) return;
          this.$confirm('提交发票申请后，将进入发票申请审批流程，不支持撤回，请确认是否提交申请', '申请详情', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(async () => {
            const params = Object.assign({}, this.invoiceInfo);
            params.recordIds = params.recordIds.join(',');
            params.deductIds = params.deductIds.join(',');
            params.receiverId = this.address.id;
            if (params.invoiceMode == InvoiceMode.NORMAL) {
              delete params.preAmount;
            }
            delete params.redInformationSheet;
            delete params.taxInclusiveTotalAmount;
            const result = await invoiceApply(params);
            if (result) {
              const {type, id} = this.$route.params
              if (type && id) {
                this.$route.push({name: 'invoiceRecord', params: {type, id}});
              } else {
                this.$router.push('/invoice-list');
              }
            }
          }).catch(() => {});
        });
      }
    }
  }
</script>
<style lang="scss">
  
</style>